export const IS_PROTOTYPE = process.env.IS_PROTOTYPE;
export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";
export const DEBUG = IS_PROTOTYPE || IS_DEVELOPMENT;
export const HOST = IS_PROTOTYPE ? "http://www.evo.test" : "";
